<template>
  <div>
    <div class="row mb-2">
      <button v-if="userEditRight" type="button" @click="createNewPackage()" class="btn btn-info">
        New Override Package
      </button>
    </div>
    <div class="row">
      <div class="table-responsive table-bordered" v-if="packages.length > 0">
        <table class="table col-md-12">
          <thead>
            <tr class="text-nowrap">
              <th v-if="saleNumber == null">Sale #</th>
              <th>Override Support Package</th>
              <th>Description</th>
              <th>MRC (excl. VAT)</th>
              <th>MRC (incl. VAT)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="overrideSupportPackage in packages"
              :key="overrideSupportPackage.overrideSupportPackageNumber"
            >
              <td
                v-if="saleNumber == null"
                class="text-center sale-number-link"
                @click="goToSale(overrideSupportPackage.saleNumber)"
              >
                {{ overrideSupportPackage.saleNumber }}            
              </td>
               <td> {{displaySupportService(overrideSupportPackage.supportPackageNumber)}} </td>
              <td> {{ overrideSupportPackage.description }} </td>
              <td>
                {{ getPrice(overrideSupportPackage.overridesupportpackageprices, period) }}
                <span
                  v-if="userEditRight"
                  style="cursor: pointer"
                  v-tooltip="'Edit Row Price'"
                  @click="openPriceModal(overrideSupportPackage)"
                  class="pull-right"
                >
                  <em class="fa fa-edit fa-fw text-green"></em>
                </span>
              </td>
              <td>
                {{
                  getPrice(overrideSupportPackage.overridesupportpackageprices, period, true)
                }}
              </td>
              <td class="text-center">
                <button
                  v-if="userEditRight"
                  v-tooltip="'Edit Package'"
                  type="button"
                  @click="editPackage(overrideSupportPackage)"
                  class="btn btn-sm btn-info m-1"
                >
                  <em class="fa fa-edit fa-fw"></em>
                </button>
                <button
                  v-if="userEditRight"
                  v-tooltip="'Delete Package'"
                  type="button"
                  @click="deletePackage(overrideSupportPackage)"
                  class="btn btn-sm btn-primary"
                >
                  <em class="fa fa-trash fa-fw"></em>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-info col-md-12">
        No Override Packages to display
      </div>
    </div>
    <AddPriceModal
      ref="addPriceModal"
      :row-price="rowPrice"
      :new-price="newPrice"
      :package-description="packageDescription"
      @addPrice="addPrice"
      @pricesAdded="getPackages()"
    />
    <modal
      :title="
        pricePackage.overrideSupportPackageNumber ? 'Edit Package' : 'Add New Package'
      "
      ref="modifyPackage"
      size="modal-lg"
      @save="savePackage()"
    >
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> Sale Number </label>
          <input
            :disabled="saleNumber != null"
            type="text"
            class="form-control"
            v-model="pricePackage.saleNumber"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> Description </label>
          <input
            disabled
            type="text"
            class="form-control"
            v-model="pricePackage.description"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> Support Package to override </label>
          <v-select
            :options="supportPackages"
            v-model="selectedSupportPackage"
            label="description"
            clearable
            placeholder="Select Profile"
          >
          <!-- :get-option-label="getLabel" -->
          </v-select>
        </div>
      </div>
        <div class="row">
          <div class="form-group col-md-10">
            <label class="control-label"> Label </label>
            <input
              type="text"
              class="form-control"
              v-model="pricePackage.label"
            />
            <small class="text-muted">Leave blank to use Support Package description</small>
          </div>
        </div>
    </modal>
  </div>
</template>

<script>
import PriceFunctions from "./PriceFunctions";
import AddPriceModal from "@/components/Admin/Modals/AddPriceModal";
import Modal from "@/components/GeneralComponents/Modal";

export default {
  extends: PriceFunctions,
  components: {
    AddPriceModal,
    Modal,
  },
  props: {
    productNumber: {
      type: Number,
      required: false,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
    saleNumber: {
      type: String,
      required: false,
    },
    supportPackages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      period: this.getCurrentPeriod(),
      newPrice: {},
      pricePackage: {}, //this is what the modal binds to
      rowPrice: [],
      packages: [],
      packageDescription: '',
      selectedSupportPackage: {}, //this is the supportpackage you choose from dropdown
    };
  },
  mounted() {
    this.getPackages();
  },
  computed: {
  },
  methods: {
    getPackages() {
      if(this.saleNumber == null) {
        this.$http.get(this.$config.aimsAPI + "pricing/overridepackages/").then(
          (response) => {
            this.packages = response.data;
          },
          (error) => {
            this.showError("Error fetching Override Packages", error);
            console.error(error);
          }
        );
      } else {
        this.$http.get(this.$config.aimsAPI + "pricing/overridepackages/" + this.saleNumber).then(
          (response) => {
            this.packages = response.data;
          },
          (error) => {
            this.showError("Error fetching Sale's Override Packages", error);
            console.error(error);
          }
        );
      }
    },
    createNewPackage() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/new/package/OverrideSupportPackage"
        )
        .then(
          (response) => {
            this.selectedSupportPackage = {};
            this.pricePackage = response.data;
            this.pricePackage.productNumber = this.productNumber;
            this.pricePackage.saleNumber = (this.saleNumber != null) ? this.saleNumber : "0";
            this.$refs.modifyPackage.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Package Template", error);
          }
        );
    },
    editPackage(overrideSupportPackage) {
      //this is to display the selected SupportPackage to override
      this.selectedSupportPackage = this.supportPackages.find( s => s.supportPackageNumber == overrideSupportPackage.supportPackageNumber); 
      this.pricePackage = this.deepCopyObject(overrideSupportPackage);
      this.$refs.modifyPackage.open();
    },
    openPriceModal(overrideSupportPackage) {
      this.rowPrice = this.deepCopyObject(overrideSupportPackage.overridesupportpackageprices);
      this.packageDescription = overrideSupportPackage.description || '';
      this.newPrice = this.deepCopyObject({
        overrideSupportPackageNumber: overrideSupportPackage.overrideSupportPackageNumber,
        class: overrideSupportPackage.class + "Price",
        validFrom: 0,
        validUntil: 0,
      });
      this.$refs.addPriceModal.open();
    },
    addPrice(newPrice) {
      this.rowPrice.forEach((price) => {
        if (price.validUntil == 0) {
          if (newPrice.validFrom % 100 > 1) {
            price.validUntil = newPrice.validFrom - 1;
          } else {
            price.validUntil = newPrice.validFrom - 100 + 11;
          }
        }
      });
      this.rowPrice.push(newPrice);
      this.newPrice = this.deepCopyObject({
        overrideSupportPackageNumber: newPrice.overrideSupportPackageNumber,
        class: newPrice.class,
        validFrom: 0,
        validUntil: 0,
      });
    },
    savePackage() {
      this.$refs.modifyPackage.isLoading();
      this.pricePackage.supportPackageNumber = this.selectedSupportPackage.supportPackageNumber;
      this.$http
        .post(
          this.$config.aimsAPI + "pricing/overridepackages/save",  this.pricePackage
        )
        .then(
          (response) => {
            this.showSuccess("Saved Package Successfully");
            this.$refs.modifyPackage.close();
            if (this.pricePackage.overrideSupportPackageNumber) {
              this.getPackages();
            } else {
              response.data.overridesupportpackageprices = [];
              this.openPriceModal(response.data);
            }
          },
          (error) => {
            this.showError("Error saving Support Packages", error);
            console.error(error);
          }
        )
        .finally(() => {
          this.$refs.modifyPackage.isLoading();
        });
    },
    deletePackage(overrideSupportPackage) {
      this.$swal({
        title: "Are you sure you want to delete this package?",
        text: overrideSupportPackage.description,
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(
              this.$config.aimsAPI +
                "pricing/overridepackages/" +
                overrideSupportPackage.overrideSupportPackageNumber
            )
            .then(
              () => {
                this.showSuccess("Successfully deleted Override Package");
                this.getPackages();
              },
              (error) => {
                this.showError("Error deleting Override Package", error);
                console.error(error);
              }
            );
        }
      });
    },
    goToSale: function(saleNumber) {
      this.initAuth();
      this.$router.replace({
        name: "search",
        query: {
          saleNumber: saleNumber,
        }
      })
    },
    displaySupportService: function(supportPackageNumber) {
      let sp = this.supportPackages.find( s => s.supportPackageNumber == supportPackageNumber); 
      return (sp != null) ? sp.description : "not found";
    }
  },
};
</script>

<style lang="css">
.sale-number-link {
  font-weight: bold;
  cursor: pointer;
  color: #5d9cec;
}


</style>
